// src/hooks/useAnalytics.js
// ✅ Hook React per tracciare eventi facilmente in qualsiasi componente
import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { track, Events } from '../utils/analytics';

const useAnalytics = () => {
    const { user, organization } = useAuth();

    const trackEvent = useCallback((event, properties = {}) => {
        track(event, {
            ...properties,
            user_role: user?.role,
            user_plan: organization?.plan,
            user_region: organization?.region,
            user_country: organization?.country,
        });
    }, [user, organization]);

    // Shortcut comuni
    const trackPageView = useCallback((page, props = {}) => trackEvent(Events.PAGE_VIEWED, { page, ...props }), [trackEvent]);
    const trackProjectCreated = useCallback((proj) => trackEvent(Events.PROJECT_CREATED, { currency: proj?.currency, has_budget: !!proj?.estimatedBudget }), [trackEvent]);
    const trackExpenseCreated = useCallback((exp) => trackEvent(Events.EXPENSE_CREATED, { category: exp?.category, amount_range: getAmountRange(exp?.totalAmount) }), [trackEvent]);
    const trackAIUsed = useCallback((feat) => trackEvent(Events.AI_MESSAGE_SENT, { feature: feat }), [trackEvent]);
    const trackUpgradeClicked = useCallback((plan) => trackEvent(Events.UPGRADE_CLICKED, { target_plan: plan }), [trackEvent]);
    const trackFeatureBlocked = useCallback((feat) => trackEvent(Events.FEATURE_BLOCKED, { feature: feat, current_plan: organization?.plan }), [trackEvent, organization]);
    const trackSearchNoResults = useCallback((query) => trackEvent(Events.SEARCH_NO_RESULTS, { query_length: query?.length }), [trackEvent]);

    return {
        trackEvent,
        trackPageView,
        trackProjectCreated,
        trackExpenseCreated,
        trackAIUsed,
        trackUpgradeClicked,
        trackFeatureBlocked,
        trackSearchNoResults,
        Events,
    };
};

// Categorizza importi senza inviare valori esatti
const getAmountRange = (amount) => {
    if (!amount) return 'unknown';
    if (amount < 1000) return 'small';
    if (amount < 10000) return 'medium';
    if (amount < 100000) return 'large';
    return 'very_large';
};

export default useAnalytics;